/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CriteriaQualifier } from './CriteriaQualifier';
import {
    CriteriaQualifierFromJSON,
    CriteriaQualifierFromJSONTyped,
    CriteriaQualifierToJSON,
    CriteriaQualifierToJSONTyped,
} from './CriteriaQualifier';

/**
 * 
 * @export
 * @interface CreateCriteriaRequest
 */
export interface CreateCriteriaRequest {
    /**
     * 
     */
    facility_id: string | null;
    /**
     * 
     */
    category_id?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    qualifier: CriteriaQualifier;
    /**
     * 
     */
    is_medication_rule?: boolean;
}



/**
 * Check if a given object implements the CreateCriteriaRequest interface.
 */
export function instanceOfCreateCriteriaRequest(value: object): value is CreateCriteriaRequest {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('qualifier' in value) || value['qualifier'] === undefined) return false;
    return true;
}

export function CreateCriteriaRequestFromJSON(json: any): CreateCriteriaRequest {
    return CreateCriteriaRequestFromJSONTyped(json, false);
}

export function CreateCriteriaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCriteriaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'category_id': json['category_id'] == null ? undefined : json['category_id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'qualifier': CriteriaQualifierFromJSON(json['qualifier']),
        'is_medication_rule': json['is_medication_rule'] == null ? undefined : json['is_medication_rule'],
    };
}

export function CreateCriteriaRequestToJSON(json: any): CreateCriteriaRequest {
    return CreateCriteriaRequestToJSONTyped(json, false);
}

export function CreateCriteriaRequestToJSONTyped(value?: CreateCriteriaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'category_id': value['category_id'],
        'name': value['name'],
        'description': value['description'],
        'qualifier': CriteriaQualifierToJSON(value['qualifier']),
        'is_medication_rule': value['is_medication_rule'],
    };
}

